import { Component, ChangeDetectionStrategy } from '@angular/core';
import { map } from 'rxjs/operators';
import { UserStorage, User } from '../user';
import { Title } from '@angular/platform-browser';
import { PageTitle } from '../core/page-title';
import { Settings } from '../core';
import { PendoService } from '../shared/pendo-service/pendo-service';

@Component({
    selector: 'dashboard-level-layout',
    template: require('./dashboard-level-layout.component.html'),
    styles: [require('./dashboard-level-layout.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardLevelLayoutComponent {
    public title$ = this.userStorage.currentUser
        .pipe(
            map(user => {
                let title: string = null;

                if (user.isAdmin || user.isSystemAdmin) {
                    title = PageTitle.getAdminTitle('Admin Dashboard');
                }

                if (user.isInternal) {
                    title = PageTitle.getAdminTitle('Internal Dashboard');
                }

                if (user.isSponsor) {
                    this.pendoService.pendoInitialization(user.metadata, this.settings.pendoSponsorApiKey);
                    title = PageTitle.getSponsorTitle('Dashboard');
                }

                if (user.isInvestigator) {
                    this.pendoService.pendoInitialization(user.metadata, this.settings.pendoInvestigatorApiKey);
                    title = PageTitle.getInvestigatorTitle('Dashboard');
                }

                if (title === null) {
                throw new Error('cannot resolve the header title, unknown audience role');
                }

                this.title.setTitle(title);
                return title;
            }
        ));

    constructor(
        private userStorage: UserStorage,
        private title: Title,
        private settings: Settings,
        private pendoService: PendoService) { }
 }